import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ColorPicker, Text } from '@reveni-io/reveni-ui'

import { availableLanguagesForUser } from '@/common/constants.js'
import { getCurrentAvailableLanguage } from '@/configuration/helpers/helpers.js'
import CodeWidget from '@/configuration/pages/ConfigurationPage/ExtrasConfiguration/CodeWidget/CodeWidget.jsx'
import CustomText from '@/configuration/pages/ConfigurationPage/ExtrasConfiguration/CustomText/CustomText.jsx'

import useCreatePreview from './WidgetPreview/useCreatePreview/useCreatePreview.js'
import WidgetPreview from './WidgetPreview/WidgetPreview.jsx'
import * as Styles from './styles.js'

const TopBannerWidgetConfiguration = ({
  backgroundColor,
  textColor,
  linkColor,
  customTexts,
  onChangeCustomTexts,
  useCustomText,
  onChangeUseCustomText,
  supportedLanguages,
  onChangeBackgroundColor,
  onChangeTextColor,
  onChangeLinkColor,
  scriptInfo,
}) => {
  const { t, i18n } = useTranslation()
  const currentLanguage = getCurrentAvailableLanguage(supportedLanguages, i18n.language)
  const [language, setLanguage] = useState(currentLanguage)

  const getAvailableLanguages = () => {
    return availableLanguagesForUser.filter(lang => supportedLanguages?.includes(lang))
  }

  useCreatePreview({
    backgroundColor,
    textColor,
    linkColor,
    customTexts,
    language,
    loadScriptContainerId: 'reveni-top-banner-widget',
    widgetContainerId: 'top-banner-widget',
  })

  const handleChangeCustomText = (value, lang) => {
    onChangeCustomTexts(texts => ({
      ...texts,
      text: {
        ...texts.text,
        [lang]: value,
      },
    }))
  }

  return (
    <Styles.Container>
      <Text type="titleM">{t('Widget top banner')}</Text>
      <Text type="bodyMRegular">
        {t(
          'Añade nuestro banner a la parte superior de las páginas de tu tienda y dales confianza en que, en caso que lo necesiten, su experiencia de cambio y devolución será rápida y fácil.'
        )}
      </Text>

      <Styles.ColorsContainer>
        <Text type="titleS">{t('Colores del widget')}</Text>
        <Styles.ColorsPickerContainer>
          <ColorPicker
            onChange={onChangeBackgroundColor}
            label={t('Color del fondo')}
            type="colorPreview"
            defaultColor={backgroundColor}
          />
          <ColorPicker
            onChange={onChangeTextColor}
            label={t('Color del texto')}
            type="colorPreview"
            defaultColor={textColor}
          />
          <ColorPicker
            onChange={onChangeLinkColor}
            label={t('Color del link')}
            type="colorPreview"
            defaultColor={linkColor}
          />
        </Styles.ColorsPickerContainer>
      </Styles.ColorsContainer>

      <Styles.DisplayContainer>
        <Text type="titleS">{t('Texto del widget')}</Text>
        <CustomText
          languages={getAvailableLanguages()}
          onChangeCustomText={handleChangeCustomText}
          customTexts={customTexts?.text}
          onCheckUseCustomText={e => onChangeUseCustomText(e.target.checked)}
          useCustomText={useCustomText}
          supportedLanguages={supportedLanguages}
          title={t('Texto')}
          switchLabel={t('Usar texto personalizado')}
          textLanguage={language}
          setTextLanguage={setLanguage}
        />
      </Styles.DisplayContainer>

      <WidgetPreview
        backgroundColor={backgroundColor}
        textColor={textColor}
        linkColor={linkColor}
        loadScriptContainerId="reveni-preview-top-banner"
        widgetContainerId="reveni-top-banner-widget"
        title={t('Vista previa')}
        language={language}
        customTexts={customTexts}
      />
      <CodeWidget scriptInfo={scriptInfo} />
    </Styles.Container>
  )
}

export default TopBannerWidgetConfiguration
